import { useIntl } from 'react-intl';

export function NotFoundContent() {
  const intl = useIntl();
  return (
    <section className="grid content-start gap-4">
      <h1 className="m-0 text-[clamp(2.4rem,7vw,4.5rem)] leading-[0.98] font-semibold tracking-[-0.045em]">
        404
      </h1>
      <h2>{intl.formatMessage({ id: 'web.notFound.title' })}</h2>
      <p className="my-8 max-w-[31rem] text-lg leading-relaxed text-muted-foreground">
        {intl.formatMessage({ id: 'web.notFound.description' })}
      </p>
    </section>
  );
}
